export enum EmployeeRole {
    Employee,
    Leader,
}
